/**
 * parent, children, item, button, initItem
 * @param { parent, children, item, button, initItem} listNode
 */
export function funcExpandContent(listNode) {
	const { parent, children, item, button, initItem, gap = 0 } = listNode;
	if (!$(parent).length) return;
	let itemHeight = $(item).outerHeight();
	let gapCalculate = gap ? Number($(parent).find(children).css("column-gap").slice(0, -2)) * gap : 0;
	let initHeight = itemHeight * initItem + gapCalculate;
	let originalHeight = $(parent).find(children).outerHeight();
	if (originalHeight < initHeight) {
		$(button).remove();
	} else {
		$(parent).css("height", initHeight);
	}
	$(button).on("click", function () {
		if ($(this).hasClass("expand")) {
			$(parent).css("height", initHeight);
			$(this).find("span").text("Xem thêm");
		} else {
			$(parent).css("height", originalHeight);
			// setTimeout(() => {
			// 	$(parent).css("height", "auto");
			// }, 1000);
			$(this).find("span").text("Rút gọn");
		}
		$(this).toggleClass("expand");
	});
}

export function clickScrollToDiv(nodeEle, heightSpacing = () => {}) {
	$(nodeEle).on("click", function (event) {
		let height = 0;
		$(this).addClass("active").siblings().removeClass("active");
		if (heightSpacing) {
			height = heightSpacing();
		} else {
			height = 0;
		}
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			$("html, body").animate({
				scrollTop: $(hash).offset().top - height,
			}, 800);
		}
	});
}

export function appendCaptchaASP() {
	if (!$("#ctl00_mainContent_ctl01_pnlFormWizard").length) return;
	// Select the div element you want to observe
	const myDiv = document.querySelector("#ctl00_mainContent_ctl01_pnlFormWizard");
	// Create a new MutationObserver object
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			console.log("Run");
			appendCaptcha();
		});
	});
	// Configure the observer to listen for changes to the "class" attribute
	const config = { attributes: true, characterData: true, childList: true };
	// Start observing the target div element
	observer.observe(myDiv, config);
	function appendCaptcha() {
		$(".form-group.frm-captcha").appendTo(".wrap-form-submit");
		$(".form-group.frm-btnwrap").appendTo(".wrap-form-submit");
	}
	appendCaptcha();
}

export function toggleFilterMobile() {
	// Generalized toggle function for filters
	function setupToggle(buttonClass, boxClass, backdropClass, closeClass) {
		// Toggle box and backdrop on button click
		$(buttonClass).on('click', function () {
			$(boxClass).toggleClass('active');
			$(backdropClass).fadeToggle();
		});
		// Close box and backdrop on close button click
		$(closeClass).on('click', function () {
			$(boxClass).removeClass('active');
			$(backdropClass).fadeOut();
		});
		// Close box and backdrop if clicked outside of the box or button
		$(document).on('click', function (e) {
			if (!$(e.target).closest(buttonClass).length && !$(e.target).closest(closeClass).length && !$(e.target).closest(boxClass).length) {
				$(boxClass).removeClass('active');
				$(backdropClass).fadeOut();
			}
		});
	}

	// Set up toggles for each type
	setupToggle('.button-filter-mobile', '.box-filter', '.backdrop-filter', '.close-filter');
}
var buttonCTA = $(".toggle-cta");
export function CTAInit() {
	if (window.matchMedia("(max-width: 1199.98px)").matches) {
		buttonCTA.on("click", function () {
			$(this).toggleClass("active").siblings().removeClass("active");
		});
		$(document).on("click", function (e) {
			if (!$(e.target).closest($(buttonCTA)).length && !$(e.target).closest(".cta-icon").length)
				buttonCTA.removeClass("active");
		});
	}
}
